import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { MdPhoneForwarded } from 'react-icons/md';

import {
  MessageReceived,
  MessageCount,
  TagBody,
  LeftZone,
  RightZone,
  QueueName,
  TimeZone,
  NameZone,
  NameCustomer,
  ChannelZone,
  TagZone,
  SaveChatZone,
  QueueColorZone,
  IconMarked,
  ExternalZoneCardChat,
  BodyLeftZone
} from '../styled';
import { getProps } from './assets';
import { TagChatClient } from '../../../../../../components/TagChatClient';
import { IconsChannel } from '../../../../../../components/IconsChannel/IconsChannel';
import { TimeIndividualChat } from './components/TimeIndividualChat';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';
import AlertCustomerTag from './components/AlertCustomer';
import AlertAgentTag from './components/AlertAgent';

const QueueTag = ({
  conversation = {},
  allQueues = [],
  functionAnswerConversation,
  idNameTags = {},
  checked = false
}) => {
  const { chatsSaved, checkIfChatIsSaved, saveChat, allChats } =
    useQueueContentChatContext();
  const [countTags, setCountTags] = useState(0);
  const [newMessagesCount, setNewMessagesCount] = useState(0);
  const [isSaved, setIsSaved] = useState(false);
  //const [isInAttendance, setIsInAttendance] = useState(false);

  const conversationInAttendance = useSelector(
    (state) => state.conversationInAttendance
  );

  useEffect(() => {
    getIndicatorNewMessages();
    setCountTags(conversation?.tags?.length || 0);

    setIsSaved(checkIfChatIsSaved(conversation?._id ?? conversation?.id));
  }, [conversation, allChats]);

  const getIndicatorNewMessages = useCallback(() => {
    conversation.novas_mensagens > 99
      ? setNewMessagesCount('+99')
      : setNewMessagesCount(conversation.novas_mensagens);
  }, [conversation?.novas_mensagens]);

  const queueColor = useMemo(() => {
    const result = allQueues?.find((el) => conversation?.fila === el?.name);
    return result?.color || 'green';
  }, [conversation?.fila]);

  const tagProps = useMemo(() => {
    const chatInAttendanceId =
      conversationInAttendance?.conversation?._id ??
      conversationInAttendance?.conversation?.id;
    const chatId = conversation?._id ?? conversation?.id;
    if (chatInAttendanceId === chatId) return getProps('atendida');
    return getProps(conversation.situacao);
  }, [conversation, conversationInAttendance, allQueues]);

  const answerConversation = useCallback(async () => {
    functionAnswerConversation(
      conversation,
      conversation._id ?? conversation.id,
      conversation.meioTransferencia,
      conversation.cliente.telefone,
      conversation.canal
    );
  }, [functionAnswerConversation, conversation]);

  const getChannelIcon = useCallback((channel, transferMode) => {
    if (transferMode === 'call') {
      return <MdPhoneForwarded size="18" color="#d9534f" />;
    } else {
      return <IconsChannel channel={channel} showName={false} />;
    }
  }, []);

  const makeTitle = useCallback(() => {
    if (!conversation) return '';
    return `Cliente: ${conversation?.cliente?.nome} \nFila: ${
      conversation.fila
    }\nCanal: ${conversation?.canal}\nMeio de transferência: ${
      conversation.meioTransferencia === 'call'
        ? 'Ligação\nRealize o login em algum ramal para continuar o atendimento!'
        : 'Chat'
    }\nMensagens não lidas: ${newMessagesCount}`;
  }, [conversation, newMessagesCount]);

  useEffect(() => {
    setIsSaved(checkIfChatIsSaved(conversation._id ?? conversation.id));
  }, [chatsSaved]);

  const customerTas = useMemo(() => {
    return conversation?.tags;
  }, [conversation?.tags]);

  if (!conversation) return null;

  return (
    <ExternalZoneCardChat
      onClick={answerConversation}
      checked={checked}
      title={makeTitle()}
    >
      <TagBody>
        <LeftZone>
          <QueueColorZone color={queueColor} />
          <BodyLeftZone>
            <NameZone className="mt--2">
              <NameCustomer> {conversation?.cliente?.nome}</NameCustomer>
              <ChannelZone>
                {getChannelIcon(
                  conversation?.canal,
                  conversation?.meioTransferencia
                )}
              </ChannelZone>
            </NameZone>
            <QueueName className="mt--2 text-muted">
              Em: {conversation.fila}
            </QueueName>
            <TagZone>
              {customerTas && countTags > 2 ? (
                <>
                  <TagChatClient
                    name={idNameTags[customerTas[0]]?.name}
                    color={idNameTags[customerTas[0]]?.color || '#5086c1'}
                    disabled={idNameTags[customerTas[0]]?.disabled}
                  />
                  <TagChatClient
                    name={idNameTags[customerTas[1]]?.name}
                    color={idNameTags[customerTas[1]]?.color || '#5086c1'}
                    disabled={idNameTags[conversation.tags[1]]?.disabled}
                  />
                  <TagChatClient
                    name={`+${countTags - 2}`}
                    allTags={customerTas}
                    idNameTags={idNameTags}
                    isMore={true}
                    color="#5086c1"
                    index={conversation?.id}
                  />
                </>
              ) : (
                <>
                  {Object.keys(idNameTags).length > 0 &&
                    customerTas &&
                    customerTas?.map((tag, index) => (
                      <TagChatClient
                        key={index}
                        name={idNameTags[tag]?.name}
                        color={idNameTags[tag]?.color || '#5086c1'}
                        disabled={idNameTags[tag]?.disabled}
                      />
                    ))}
                </>
              )}
            </TagZone>
          </BodyLeftZone>
        </LeftZone>
        <RightZone>
          <TimeZone className="mt--2">
            <TimeIndividualChat conversation={conversation} />
          </TimeZone>
          <AlertCustomerTag
            situation={conversation.situacao}
            status={tagProps?.status}
            chatId={conversation._id || conversation.id}
          />

          <MessageReceived>
            <div style={{ display: 'flex' }}>
              {newMessagesCount > 0 && (
                <MessageCount> {newMessagesCount} </MessageCount>
              )}
            </div>
            <AlertAgentTag chatId={conversation._id || conversation.id} />
          </MessageReceived>
          <SaveChatZone>
            <IconMarked
              strokeWidth={8}
              stroke="#0f172a"
              isSaved={isSaved}
              size={20}
              onClick={(e) => {
                saveChat(conversation._id ?? conversation.id);
                e.stopPropagation();
              }}
            />
          </SaveChatZone>
        </RightZone>
      </TagBody>
    </ExternalZoneCardChat>
  );
};

export default QueueTag;
